export const GET_COURIER_PHONE = Symbol('GET_COURIER_PHONE');
export const GET_COURIER_PHONE_REQUEST = Symbol('GET_COURIER_PHONE_REQUEST');
export const GET_COURIER_PHONE_SUCCESS = Symbol('GET_COURIER_PHONE_SUCCESS');
export const GET_COURIER_PHONE_ERROR = Symbol('GET_COURIER_PHONE_ERROR');

export const CLEAR_COURIER_PHONE = Symbol('CLEAR_COURIER_PHONE');
